/**
 * Marker3D parser: the Node3D transform surface plus `gizmo_extents`, the cross
 * gizmo's arm length (Godot default 0.25 world units).
 */
import { parseNode3D } from '../../base/node3d/parser';
import { floatOr } from '../../../parser/valueParsers';
export function parseMarker3D(heading, properties) {
    const base = parseNode3D(heading, properties);
    return {
        ...base,
        gizmo_extents: floatOr(properties.gizmo_extents, 0.25),
    };
}
//# sourceMappingURL=parser.js.map